const KEY = "malaku_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => localStorage.setItem(KEY, t);
export const removeToken = () => localStorage.removeItem(KEY);
export const isAuthenticated = () => !!localStorage.getItem(KEY);
